
(function () {
  'use strict';

  /* ---- Route /cart/add through a native fetch on this template */
  (function () {
    var nativeFetch;
    try {
      var ifr = document.createElement('iframe');
      ifr.setAttribute('aria-hidden', 'true');
      ifr.setAttribute('tabindex', '-1');
      ifr.style.display = 'none';
      (document.documentElement || document.body).appendChild(ifr);
      nativeFetch = ifr.contentWindow && ifr.contentWindow.fetch;
    } catch (e) {}
    if (typeof nativeFetch !== 'function') return; // no clean fetch → leave as-is

    function isCartAdd(input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      return /\/cart\/add(\.js)?([?#]|$)/.test(url);
    }

    var ours = null;
    function install() {
      if (window.fetch === ours) return;      // still ours — nothing to do
      var prev = window.fetch;                 // FIXED snapshot of the current fetch
      if (typeof prev !== 'function') return;
      ours = function revamCartAddFetch(input, init) {
        if (isCartAdd(input)) {
          try { return nativeFetch(input, init); } catch (e) {}
        }
        return prev.apply(this, arguments);    // prev is fixed → finite chain, no recursion
      };
      try { window.fetch = ours; } catch (e) { ours = null; }
    }

    install();
    // Re-assert if an app (e.g. Appstle's init poll) swaps window.fetch after us.
    var ticks = 0;
    var timer = setInterval(function () {
      install();
      if (++ticks > 40) clearInterval(timer);  // ~20s is plenty for apps to init
    }, 500);
  })();

  function formatMoney(cents, symbol) {
    if (isNaN(cents)) return '';
    var value = (cents / 100).toFixed(2);
    // Add thousands separators
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return symbol + parts.join('.');
  }

  window.RevamPDP = {
    init: function () {
      /* ---- Modal close-button fix (scoped to revam PDP only) */
      var revamRoot = document.querySelector('[data-revam-pdp]');
      if (revamRoot) {
        var modal = document.querySelector('product-modal.media-modal');
        if (modal) {
          var closeBtn = modal.querySelector('[id^="ModalClose-"]');
          if (closeBtn) {
            closeBtn.addEventListener('click', function (event) {
              event.preventDefault();
              event.stopPropagation();
              modal.hide();
            });
          }
          // Guard backdrop handlers so taps on the close button don't trigger a double-close
          modal.addEventListener('pointerup', function (event) {
            if (event.pointerType === 'mouse' &&
                !event.target.closest('deferred-media, product-model') &&
                !event.target.closest('[id^="ModalClose-"]')) {
              modal.hide();
            }
          });
          modal.addEventListener('touchend', function (event) {
            if (!event.target.closest('deferred-media, product-model') &&
                !event.target.closest('[id^="ModalClose-"]')) {
              modal.hide();
            }
          });
        }
      }

      /* ---- Mobile gallery: select non-active image, open modal on active ----
         On mobile, tapping a NON-active gallery image selects it (scrolls the
         slider). Tapping the ALREADY-ACTIVE image opens the fullscreen modal
         (zoom). Desktop keeps the modal (zoom) behavior for all images.
         Scoped to [data-revam-pdp] so other templates are unaffected. */
      function setupMobileGallerySelect() {
        if (window.matchMedia('(min-width: 990px)').matches) return; // desktop keeps modal
        var gallery = revamRoot.querySelector('media-gallery');
        if (!gallery) return;
        var modalOpeners = revamRoot.querySelectorAll('modal-opener.product__modal-opener');
        modalOpeners.forEach(function (opener) {
          opener.addEventListener('click', function (event) {
            // Is this the currently-active media? Active <li> has class is-active.
            var slideItem = opener.closest('.product__media-item');
            var isActive = slideItem && slideItem.classList.contains('is-active');
            if (isActive) return; // let the modal open (zoom) — don't intercept
            // Non-active image: select it instead of opening the modal
            event.preventDefault();
            event.stopPropagation();
            var mediaBtn = opener.querySelector('[data-media-id]');
            var rawId = mediaBtn ? mediaBtn.getAttribute('data-media-id') : null;
            if (!rawId) return;
            var sectionId = gallery.id.replace('MediaGallery-', '');
            var fullId = sectionId + '-' + rawId;
            if (typeof gallery.setActiveMedia === 'function') {
              gallery.setActiveMedia(fullId, false);
            }
          }, { capture: true });
        });
      }
      setupMobileGallerySelect();
      // Re-run if the gallery re-renders (variant change swaps media)
      window.matchMedia('(min-width: 990px)').addEventListener('change', function () {
        if (!window.matchMedia('(min-width: 990px)').matches) setupMobileGallerySelect();
      });

      var tiers = document.querySelector('[data-revam-tiers]');
      var options = document.querySelector('[data-revam-options]');
      if (!tiers) return; // nothing to do on this template

      var symbol = tiers.getAttribute('data-currency-symbol') || '$';

      /* ---- State */
      var state = {
        base: parseInt(tiers.getAttribute('data-base-price'), 10) || 0,
        tier: parseInt(tiers.getAttribute('data-default-tier'), 10) || 2,
        subscription: options ? options.getAttribute('data-default-mode') === 'subscription' : false,
        planDiscount: 0,
        sellingPlanId: '',
      };

      /* ---- Elements */
      var qtyInput = tiers.querySelector('[data-revam-quantity-input]');
      var tierEls = tiers.querySelectorAll('[data-revam-tier]');
      var planInput = options ? options.querySelector('[data-revam-selling-plan-input]') : null;
      var frequencySelect = options ? options.querySelector('[data-revam-frequency]') : null;
      var optionCards = options ? options.querySelectorAll('[data-revam-option]') : [];

      /* ---- Helpers */
      function tierDiscount(qty) {
        var el = tiers.querySelector('[data-revam-tier][data-qty="' + qty + '"]');
        return el ? parseFloat(el.getAttribute('data-discount')) || 0 : 0;
      }

      function recompute() {
        // Read subscription plan discount from the selected frequency option
        if (frequencySelect) {
          var opt = frequencySelect.options[frequencySelect.selectedIndex];
          state.planDiscount = opt ? parseFloat(opt.getAttribute('data-discount')) || 0 : 0;
          state.sellingPlanId = opt ? opt.value : '';
        }

        var subMult = state.subscription ? (1 - state.planDiscount) : 1;
        var disc = tierDiscount(state.tier);
        var perKit = state.base * subMult * (1 - disc);
        var total = perKit * state.tier;
        var oneTimeTotal = state.base * state.tier * (1 - disc);
        var savings = oneTimeTotal - total;

        /* Update each tier card's price + savings */
        tierEls.forEach(function (el) {
          var qty = parseInt(el.getAttribute('data-qty'), 10);
          var tDisc = tierDiscount(qty);
          var tPerKit = state.base * subMult * (1 - tDisc);
          var tTotal = tPerKit * qty;
          /* Savings vs full base price (base x qty) — always meaningful, */
          var tSavings = (state.base * qty) - tTotal;
          var priceEl = el.querySelector('[data-revam-tier-price]');
          var saveEl = el.querySelector('[data-revam-tier-save]');
          if (priceEl) {
            priceEl.textContent = qty > 1
              ? formatMoney(tPerKit, symbol)
              : formatMoney(tTotal, symbol);
          }
          if (saveEl && tSavings > 0) {
            saveEl.textContent = formatMoney(tSavings, symbol);
          } else if (saveEl) {
            saveEl.textContent = '';
          }
          /* Badge text is static (rendered in Liquid) — never recomputed here. */
        });

        /* Update subscription card compare/price + one-time card price. */
        if (options) {
          var planMult = 1 - state.planDiscount;                        // sub frequency discount (always applied here)
          var regularTotal = state.base * (1 - disc) * state.tier;      // one-time / regular price for this tier
          var subCardTotal = state.base * planMult * (1 - disc) * state.tier; // subscription-discounted price
          var subPriceEl = options.querySelector('[data-revam-sub-price]');
          var subCompareEl = options.querySelector('[data-revam-sub-compare]');
          var onetimePriceEl = options.querySelector('[data-revam-onetime-price]');
          if (subPriceEl) subPriceEl.textContent = formatMoney(subCardTotal, symbol);
          if (subCompareEl) {
            subCompareEl.textContent = formatMoney(regularTotal, symbol);
            // Only show the struck-through regular price when there's an actual saving.
            subCompareEl.style.display = subCardTotal < regularTotal ? '' : 'none';
          }
          if (onetimePriceEl) onetimePriceEl.textContent = formatMoney(regularTotal, symbol);
        }

        /* Sync hidden form inputs */
        if (qtyInput) qtyInput.value = state.tier;
        if (planInput) planInput.value = state.subscription ? state.sellingPlanId : '';
      }

      function selectTier(qty) {
        state.tier = qty;
        tierEls.forEach(function (el) {
          var isSel = parseInt(el.getAttribute('data-qty'), 10) === qty;
          el.classList.toggle('is-selected', isSel);
          el.setAttribute('aria-checked', isSel ? 'true' : 'false');
        });
        recompute();
      }

      function selectMode(mode) {
        state.subscription = mode === 'subscription';
        if (options) {
          optionCards.forEach(function (card) {
            var isSel = card.getAttribute('data-mode') === mode;
            card.classList.toggle('is-selected', isSel);
            card.setAttribute('aria-checked', isSel ? 'true' : 'false');
          });
        }
        recompute();
      }

      /* ---- Wire tier cards */
      tierEls.forEach(function (el) {
        el.addEventListener('click', function () {
          selectTier(parseInt(el.getAttribute('data-qty'), 10));
        });
        el.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            selectTier(parseInt(el.getAttribute('data-qty'), 10));
          }
        });
      });

      /* ---- Wire option cards + frequency */
      if (options) {
        optionCards.forEach(function (card) {
          card.addEventListener('click', function () {
            selectMode(card.getAttribute('data-mode'));
          });
          card.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              selectMode(card.getAttribute('data-mode'));
            }
          });
        });
        if (frequencySelect) {
          frequencySelect.addEventListener('change', recompute);
        }
      }

      /* ---- Neutralize duplicate selling_plan inputs (Appstle/Loop) */
      function neutralizeDuplicatePlans() {
        document.querySelectorAll('input[name="selling_plan"]').forEach(function (input) {
          if (input === planInput) return;
          input.setAttribute('data-revam-neutralized', '');
          input.disabled = true;
          input.removeAttribute('name');
        });
      }

      function watchForDuplicatePlans() {
        if (!('MutationObserver' in window)) return;
        var observer = new MutationObserver(function (mutations) {
          var touched = false;
          mutations.forEach(function (m) {
            m.addedNodes.forEach(function (node) {
              if (node.nodeType !== 1) return;
              if (node.matches && node.matches('input[name="selling_plan"]')) touched = true;
              if (node.querySelector && node.querySelector('input[name="selling_plan"]')) touched = true;
            });
          });
          if (touched) neutralizeDuplicatePlans();
        });
        observer.observe(document.body, { childList: true, subtree: true });
      }

      /* ---- Re-read base price on variant change */
      if (window.PUB_SUB_EVENTS && typeof window.subscribe === 'function') {
        window.subscribe(window.PUB_SUB_EVENTS.variantChange, function (evt) {
          var v = evt && evt.data && evt.data.variant;
          if (v && typeof v.price !== 'undefined') {
            state.base = v.price;
            recompute();
          }
        });
      }

      /* ---- "Preguntas frecuentes" link → scroll to the FAQ tabs below */
      var faqLink = document.querySelector('[data-revam-faq-link]');
      if (faqLink) {
        faqLink.addEventListener('click', function (e) {
          var target = document.querySelector('.product__accordion, details.accordion, [id^="ProductAccordion"]');
          if (!target) return;
          e.preventDefault();
          var opener = target.closest('details') || target;
          if (opener && opener.tagName === 'DETAILS') opener.open = true;
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }

      /* ---- Init */
      neutralizeDuplicatePlans();
      watchForDuplicatePlans();
      recompute();
    },
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.RevamPDP.init);
  } else {
    window.RevamPDP.init();
  }

  /* ---- Remove the Appstle Bundles volume-discount widget on this template */
  (function () {
    var SEL = '.ab-volume-discount-container, [appstle-volume-discount-unique-reference="VOLUME_DISCOUNT"]';
    function removeBundleWidget() {
      document.querySelectorAll(SEL).forEach(function (el) { el.remove(); });
    }
    function start() {
      removeBundleWidget();
      if (!('MutationObserver' in window)) return;
      var obs = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var node = added[j];
            if (node.nodeType !== 1) continue;
            if ((node.matches && node.matches(SEL)) ||
                (node.querySelector && node.querySelector(SEL))) {
              removeBundleWidget();
              return;
            }
          }
        }
      });
      obs.observe(document.documentElement, { childList: true, subtree: true });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
})();
